import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
const ContactUs = () => {
  useEffect(() => {
    document.title = "Contact Us -  The Air Force School Subroto Park";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> About Us </li>
          <li>Contact Us</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Contact Us </h1>
            </div>
          </div>
          <div className="row phone">
            <div className="col-lg-4">
              <h6>Phone</h6>
              <p>
                <Link to="tel:91-11-25693063">
                  {" "}
                  +91-11-25693063 (Senior School){" "}
                </Link>
              </p>
              <p>
                <Link to="tel:+91-11-25693627">
                  {" "}
                  +91-11-25693627 (Junior School){" "}
                </Link>
              </p>
              <p>
                <Link to="tel:+91-11-25696365">
                  {" "}
                  +91-11-25696365 (Principal Office){" "}
                </Link>
              </p>
              <p>
                <Link to="tel:+91-11-25691356">
                  {" "}
                  +91-11-25691356 (Section Officer){" "}
                </Link>
              </p>
              <p>
                <Link to="tel:+91-11-25683008">
                  {" "}
                  +91-11-25683008 (Boarding House){" "}
                </Link>
              </p>
              <p>WAC 25687194 Ext. 5090</p>
              <p>Telefax: +91-11-25696365</p>
            </div>
            {/* <div className="col-lg-4">
              <h6>Mobile</h6>
              <p>
                <Link to="tel:9651388226">Section Officer – 9651388226 </Link>
              </p>
              <p>
                <Link to="tel:9650263828">Estate Supdt. – 9650263828 </Link>
              </p>
              <p>
                <Link to="tel:8527978707">Warden - 8527978707 </Link>
              </p>
            </div> */}

            <div className="col-lg-4">
              <h6>Email</h6>
              <p>
                <Link to="mail:tafsdelhi@gmail.com">
                  tafsdelhi@gmail.com (School){" "}
                </Link>
              </p>
              <p>
                <Link to="mail:principal.tafs@gmail.com">
                  principal.tafs@gmail.com (Principal){" "}
                </Link>
              </p>
              <p>
                <Link to="mail:headmistress.tafs@gmail.com">
                  headmistress.tafs@gmail.com (HM Junior School){" "}
                </Link>
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.4462654391286!2d77.14926868707786!3d28.586386123506728!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1d1c79c8edb3%3A0x981d1a21e78f3f6e!2sTHE%20AIR%20FORCE%20SCHOOL%2C%20SUBROTO%20PARK!5e0!3m2!1sen!2sin!4v1733129931339!5m2!1sen!2sin"
                width="100%"
                height="450"
                style={{ border: "0" }}
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
